/**
 * STT Studio localized copy — STTLayoutEnhanced and its sibling
 * components (MicrophoneRecorder, MicrophoneRecorderBox, …).
 *
 * Re-export shim over /locales/{en,ht,fr,es}.json (stt_studio key).
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.stt_studio,
  ht: ht.stt_studio,
  fr: fr.stt_studio,
  es: es.stt_studio,
  'pt-BR': ptBR.stt_studio,
  'zh-Hans': zhHans.stt_studio,
}

export default COPY
